import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core'
import { getPatternCategoryProperties } from '../c-job/c-job.util'

@Component({
  selector: 'pattern-trait-pill',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <button
      class="e11-border e11-transition-all e11-cursor-pointer e11-px-4 e11-pt-0.5 e11-rounded-[4px] e11-text-sm e11-text-center"
      type="button"
      [style.color]="textColor()"
      [style.background-color]="bgColor()"
      [style.border-color]="patternProperties()?.color"
      (mouseenter)="hover(true)"
      (mouseleave)="hover(false)"
      (click)="onSelect.emit()"
    >
      {{ patternName() }}
    </button>
  `,
})
export class PatternTraitPillComponent {
  patternName = input.required<string>()
  isChecked = input<boolean>(false)

  onSelect = output<void>()

  isHovered = signal(false)

  patternProperties = computed(() => getPatternCategoryProperties(this.patternName()))
  bgColor = computed(() => {
    const isChecked = this.isChecked()
    const isHovered = this.isHovered()
    if (isHovered && !isChecked) return `${this.patternProperties()?.color}1A`
    return isChecked ? this.patternProperties()?.color : this.patternProperties()?.secondaryColor
  })
  textColor = computed(() => (this.isChecked() ? this.patternProperties()?.textColor : this.patternProperties()?.secondaryTextColor))

  hover(state: boolean) {
    this.isHovered.set(state)
  }
}
